<template>
	<div class="two-step-form step-1" :id="advanced.cssId" :class="[advanced.cssClasses, responsiveClasses]">
		<div class="tsf-inner" :style="style">
			<div :class="['tsf-header']">
				<div class="tsf-item" v-for="(item, index) in (formContent ? formContent.formHeader : {})" :key="index">
          <span class="tsf-number">
              <span class="step_number">{{ item.step }}</span>
              <i class="icon icon-check"></i>
          </span>
					<div class="right">
						<h3 :style="headlineStyle">{{ item.title }}</h3>
						<span :style="subHeadlineStyle">{{ item.subtitle }}</span>
					</div>
				</div>
			</div>

			<a class="tsf-back" >
				<i class="icon icon-back"></i>
				<span >{{ formContent && formContent.backBtn ? formContent.backBtn : 'Edit shipping details' }}</span>
			</a>

			<div class="tsf-step_1">
				<div v-for="(item, index) in step1Blocks" :key="item.id"
				     v-if="item && item.step === 1">
					<component
							:is="''+item.type"
							:details="item"
							:index="index"
							:block="item"
							:step="1" />
				</div>

			</div>

			<div class="tsf-step_2">
				<div class="form_body">
					<component
							v-for="(item, index) in step2Blocks" :key="item.id"
							:is="''+item.type"
							:details="item"
							:index="index"
							:block="item"
							:step="2"
							v-if="item && item.step === 2"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import {Container, Draggable} from 'vue-smooth-dnd'

import InputNumber from "@/modules/page-editor/src/components/sidebar/sidebar-items/InputNumber.vue"
import FormTextInput from "@/modules/page-editor/src/components/generator/form-items/FormTextInput.vue";
import FormHorizontalLine from "@/modules/page-editor/src/components/generator/form-items/FormHorizontalLine.vue";
import FormSelect from "@/modules/page-editor/src/components/generator/form-items/FormSelect.vue";
import FormStateZipInputs from "@/modules/page-editor/src/components/generator/form-items/FormStateZipInputs.vue";
import FormBlockWrapper from "@/modules/page-editor/src/components/content/FormBlockWrapper.vue";
import paymentForm from "@/modules/page-editor/src/components/generator/PaymentForm.vue";
import productList from "@/modules/page-editor/src/components/generator/ProductList.vue";
import orderBump from "@/modules/page-editor/src/components/generator/OrderBump.vue";
import OrderSummary from "@/modules/page-editor/src/components/generator/OrderSummary.vue";
import formElement from "@/modules/page-editor/src/components/generator/FormElement.vue";
import FormSpacer from "@/modules/page-editor/src/components/generator/FormSpacer";

import {borderProps, boxShadow, fontProps, getPadding} from "@/modules/page-editor/src/utils/props";
import FormButton from "@/modules/page-editor/src/components/generator/FormButton";
import Paragraph from "@/modules/page-editor/src/components/generator/Paragraph";

export default {
	name: 'EmailTwoStepForm',
	components: {
		InputNumber,
		FormTextInput,
		FormHorizontalLine,
		FormSelect,
		FormStateZipInputs,
		Container, Draggable,
		paragraph: Paragraph,
		formElement,
		'form-formElement': formElement,
		formSpacer: FormSpacer,
		FormBlockWrapper,
		paymentForm: paymentForm,
		productList: productList,
		orderBump: orderBump,
		formButton: FormButton,
		orderSummary: OrderSummary,
	},
	props: ['id', 'details', 'isPopup'],
	data: function () {
		return {}
	},
	computed: {
		...mapGetters(['page_findOne', 'page_findChild', 'page_findChildren']),
		content() {
			return this.details;
		},
		basic() {
			return this.content.attributes.basic
		},
		advanced() {
			return this.content.attributes.advanced
		},
		responsive() {
			return this.details.responsive
		},
		step1Blocks(){
			return this.page_findChildren(this.content.step1Children, this.isPopup);
		},
		step2Blocks(){
			return this.page_findChildren(this.content.step2Children, this.isPopup);
		},
		responsiveClasses() {
			let c = '';
			if (!this.responsive) return '';
			if (!this.responsive.desktop) c = 'no-desktop';
			if (!this.responsive.mobile) c += ' no-mobile';
			if (!this.responsive.tablets) c += ' no-tablet';
			return c;
		},
		formContent() {
			return this.content.content
		},
		formSecondStepItems() {
			return this.content.children
		},
		subHeadlineStyle() {
			return {
				...fontProps(this.basic.font2),
			}
		},
		headlineStyle() {
			return {
				...fontProps(this.basic.font),
			}
		},
		style() {
			return {
				...borderProps(this.basic.border),

				margin: getPadding(this.basic.margin),
				padding: getPadding(this.advanced.padding),
				backgroundColor: this.basic.backgroundColor || '#FFFFFF',
				boxShadow: boxShadow(this.basic.shadows),
			};
		},
	},
	methods: {},
	created() {}
}
</script>
